/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Media_Title_Too_LongInputs */

const vi_media_title_too_long = /** @type {(inputs: Media_Title_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tiêu đề tối đa ${i?.max} ký tự.`)
};

/**

* @param {Media_Title_Too_LongInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_title_too_long = /** @type {((inputs: Media_Title_Too_LongInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Title_Too_LongInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_title_too_long(inputs)
});